export const LocationConstants = {
    GET_LOCATIONS: 'GET_LOCATIONS',

    GETALL_LOCATIONS_REQUEST: 'GETALL_LOCATIONS_REQUEST',
    GETALL_LOCATIONS_SUCCESS: 'GETALL_LOCATIONS_SUCCESS',
    GETALL_LOCATIONS_FAILURE: 'GETALL_LOCATIONS_FAILURE'
};